<template>
  <div>
    <div class="activity">
      <!-- 返回 -->
      <div
        class="activity-return"
        :style="{ paddingTop: 10.31 + statusBarHeight + 'px' }"
        @click="handleClosePage"
      >
        <img :src="require('@/assets/images/YuliApp/weeklyTask/button_return.svg')" />
      </div>

      <!-- 弹窗图片 -->
      <div class="activity-headpic">
        <!-- 时间标题 -->
        <div class="activity-popup-deadline">
          <p class="activity-popup-deadline-text">Dealine: UTC {{ deadline }}</p>
          <img :src="require('@/assets/images/YuliApp/wenhao.png')" @click="showActivityIntro" />
        </div>
      </div>

      <!-- 弹窗 -->
      <div class="activity-popup" ref="popup">
        <!-- 弹窗内容  -->
        <div class="activity-popup-wrap" :style="{ height: `${contentHeight}px` }">
          <div class="activity-popup-prizes" v-for="(item, index) in memoriesData" :key="index">
            <PrizesBlock
              v-if="curTab === 'Prizes'"
              :levelName="item.levelName"
              :levelUrl="item.levelUrl"
              :propsName="item.propsName"
              :propsUrl="item.propsUrl"
              :amount="rewardsList[index]?.amount ? rewardsList[index].amount : 0"
            ></PrizesBlock>

            <CollectionBlock
              v-else
              :amount="item.amount"
              :levelName="item.transform_effect.toUpperCase()"
              :cardUrlList="item.cardUrlList"
              @showPropsPopup="showPropsPopup"
            ></CollectionBlock>
          </div>
        </div>
      </div>

      <!-- 弹窗底部 -->
      <div class="activity-bottom"></div>

      <!-- 弹窗按钮tab -->
      <div class="activity-button">
        <div
          :class="['activity-button-prize', curTab === 'Prizes' ? 'blue-bg' : 'grey-bg']"
          @click="changeTab('Prizes')"
        >
          Prizes
        </div>
        <div
          :class="['activity-button-collection', curTab === 'Collection' ? 'blue-bg' : 'grey-bg']"
          @click="changeTab('Collection')"
        >
          Collection
        </div>
      </div>
    </div>

    <!-- 道具详情弹窗 -->
    <MemoryDetail v-if="show_props_detail" :detail="props_detail" @close="handleCloseDetail" />

    <!-- 活动详情弹窗 -->
    <ActivityIntro v-if="show_activity_intro" @close="handleCloseIntro"></ActivityIntro>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed } from "vue";
import PrizesBlock from "./components/PrizesBlock.vue";
import CollectionBlock from "./components/CollectionBlock.vue";
import MemoryDetail from "./components/MemoryDetail";
import ActivityIntro from "./components/ActivityIntro";
import { PRIZES_TYPE } from "./constants/activity.js";
import appBridging from "@/utils/appBridging.js";
import { mapState } from "vuex";
import _ from "lodash";
import { getFragmentsDetailById } from "@/api/activity.js";
import { getTime, getUtcTime } from "@/utils/time.js";

export default {
  components: {
    PrizesBlock,
    CollectionBlock,
    ActivityIntro,
    MemoryDetail,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    }),
  },
  watch: {
    init: {
      handler(value) {
        if (!value) {
          return;
        }
        this.requestGetFragmentsDetailById();
      },
      immediate: true,
      deep: true,
    },
  },
  setup() {
    const curTab = ref("Prizes");
    const memoriesData = ref([]);
    const props_detail = ref(null);
    const show_props_detail = ref(false);
    const show_activity_intro = ref(false);
    const suipianList = ref([]);
    const rewardsList = ref([]);
    const deadline = ref("");
    const popup = ref(null);
    const popupHeight = ref(0);

    onMounted(() => {
      appBridging.getStatusBarHeight();
      memoriesData.value = PRIZES_TYPE;

      const height = popup?.value.clientHeight;
      popupHeight.value = height;

      appBridging.closeLoading();
    });

    /**
     * 设置内容高度
     */
    const contentHeight = computed(() => {
      return popupHeight.value + 18;
    });

    /**
     * 请求碎片列表
     */
    const requestGetFragmentsDetailById = () => {
      return getFragmentsDetailById().then((res) => {
        console.log("数据", res);

        const time = _.get(res, "end_at", "") * 1000;
        deadline.value = getUtcTime(time, "HH:mm") + " " + getUtcTime(time, "D/M/YYYY");

        suipianList.value = _.get(res, "data", []) || [];
        const _rewardsList = _.get(res, "rewards", []) || [];
        rewardsList.value = handleData(suipianList.value, _rewardsList);
      });
    };

    /**
     * 构造碎片数组
     */
    const handleData = (suipianList, rewardsList) => {
      let start = 0;
      let end = start + 5;
      rewardsList.forEach((item, index) => {
        item["cardUrlList"] = suipianList.slice(start, end);
        start = end;
        end = start + 5;
      });
      return rewardsList;
    };

    /**
     * 切换
     */
    const changeTab = (value) => {
      curTab.value = value;
      memoriesData.value = value === "Prizes" ? PRIZES_TYPE : rewardsList.value;
    };

    /**
     * 关闭页面
     */
    const handleClosePage = () => {
      appBridging.closePage();
    };

    /**
     * 碎片详情
     */
    const showPropsPopup = (propsItem) => {
      props_detail.value = propsItem;
      show_props_detail.value = true;
    };

    const handleCloseDetail = () => {
      show_props_detail.value = false;
      props_detail.value = null;
    };

    /**
     * 活动介绍
     */
    const showActivityIntro = () => {
      show_activity_intro.value = true;
    };
    const handleCloseIntro = () => {
      show_activity_intro.value = false;
    };

    return {
      curTab,
      memoriesData,
      props_detail,
      show_props_detail,
      show_activity_intro,
      suipianList,
      rewardsList,
      deadline,
      requestGetFragmentsDetailById,
      handleData,
      changeTab,
      handleClosePage,
      showPropsPopup,
      handleCloseDetail,
      showActivityIntro,
      handleCloseIntro,
      popup,
      contentHeight,
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}

.activity {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-image: url("~@/assets/images/YuliApp/activity_bg.png");
  background-size: 100% 100%;
  overflow: hidden;

  &-return {
    width: 64.07px;
    height: 30px;
    text-align: left;
    padding-top: 10.31px;
    img {
      width: 100%;
      height: 100%;
      margin-left: -4px;
    }
  }

  &-headpic {
    box-sizing: border-box;
    width: 351px;
    height: 240px;
    margin: 0px auto;
    margin-top: -8px;
    background-image: url("~@/assets/images/YuliApp/popup_head.png");
    background-size: 100% 100%;
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;
  }

  &-bottom {
    box-sizing: border-box;
    width: 351px;
    height: 56px;
    margin: 0px auto;
    background-image: url("~@/assets/images/YuliApp/popup_bottom.png");
    background-size: 100% 100%;
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;
  }

  &-popup {
    box-sizing: border-box;
    width: 351px;
    height: 334px;
    margin: 0 auto;
    background-image: url("~@/assets/images/YuliApp/popup_bg_2.png");
    background-size: 100% 100%;
    flex-grow: 0;
    flex-shrink: 1;

    &-wrap {
      box-sizing: border-box;
      width: 287px;
      height: 0px;
      overflow: scroll;
      position: relative;
      margin: 0 auto;
      top: -10px;
      bottom: 0px;
    }

    &-deadline {
      width: 100%;
      height: 41px;
      line-height: 41px;
      position: absolute;
      bottom: 20px;
      right: 0px;

      &-text {
        display: inline-block;
        vertical-align: middle;
        color: rgba(255, 255, 255, 1);
        font-size: 13px;
        font-weight: 400;
        font-family: "Josefin Sans";
        line-height: 15.6px;
        opacity: 0.9;
        white-space: nowrap;
      }

      img {
        width: 24px;
        height: 24px;
        object-fit: cover;
        vertical-align: middle;
        position: absolute;
        right: 32px;
        bottom: 9px;
      }
    }
  }

  &-button {
    display: flex;
    align-items: center;
    margin-top: -16px;
    padding-left: 49px;
    padding-bottom: 80px;
    flex-grow: 0;
    flex-shrink: 0;
    z-index: 1;

    &-prize {
      width: 86px;
      height: 45px;
      background-size: 100% 100%;
      font-size: 13px;
      font-weight: 400;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 36px;
    }
    &-collection {
      width: 86px;
      height: 45px;
      background-size: 100% 100%;
      font-size: 13px;
      font-weight: 400;
      font-family: "PingFang HK";
      text-align: center;
      line-height: 36px;
    }
    .blue-bg {
      color: rgba(196, 219, 239, 1);
      background-image: url("~@/assets/images/YuliApp/button_blue@2x.png");
    }
    .grey-bg {
      color: rgba(105, 117, 150, 1);
      background-image: url("~@/assets/images/YuliApp/button_grey@2x.png");
    }
  }
}
</style>